import styled from 'styled-components';
import { H1, P } from 'components/Typography';
import Container from 'components/Container';
import _Button from 'components/Button';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ErrorContainer = styled(Container)`
  padding-bottom: 0;
  padding-top: 160px;
  height: 100%;
  min-height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  @media ${sizes.desktop} {
    margin: 0 50px;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Content = styled.div``;

export const Title = styled(H1)`
  font-size: 40px;

  line-height: 0.9;
  color: ${th('colors.white')};

  @media ${sizes.tabletPortrait} {
    font-size: 45px;
  }

  @media ${sizes.tabletLandscape} {
    font-size: 4vw;
  }

  @media ${sizes.largeDesktop} {
    font-size: 50px;
  }
`;

export const SubTitle = styled(P)`
  margin: 30px 0;
  font-size: 17px;
  max-width: 700px;
  font-weight: normal;
  color: ${th('colors.white')};

  @media ${sizes.tabletPortrait} {
    font-size: 22px;
  }
  @media ${sizes.desktop} {
    font-size: 22px;
  }
`;

export const Button = styled(_Button)`
  margin-top: 30px;
  max-width: max-content;
  background-color: ${th('colors.turquoise')};
  color: ${th('colors.black')};

  :hover {
    background-color: ${th('colors.turquoise')};
    color: ${th('colors.white')};
  }
`;

export const Image = styled.div`
  display: flex;
  align-items: center;

  > img {
    width: 100%;
    max-width: 400px;
    position: absolute;
    bottom: -150px;
    left: -15px;
  }

  @media ${sizes.desktop} {
    > img {
      position: initial;
      bottom: 0;
      margin-top: 0;
      max-width: 600px;
    }
  }
`;
